import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
import styled from 'styled-components';
import { noop } from '../../helpers';
import Theme from '../../theme';
var SCAnchor = styled.a.withConfig({
  displayName: "Anchor__SCAnchor",
  componentId: "sc-1hh7cxf-0"
})(["color:", ";text-decoration:none;cursor:pointer;outline:0;&[disabled]{color:", ";cursor:default;}&:not([disabled]){&:hover{color:", ";text-decoration:none;}}font-family:", ";"], Theme.colours.linkblue, Theme.colours.grey_cc, Theme.colours.bluehover, function (props) {
  return props.secondary ? Theme.fonts.families.LatoRegular : Theme.fonts.families.LatoBold;
});
var Anchor = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Anchor, _Component);
  function Anchor() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Anchor.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(SCAnchor, {
      className: this.props.className,
      id: this.props.id,
      href: this.props.href,
      role: this.props.role,
      "aria-label": this.props.ariaLabel,
      target: this.props.target,
      title: this.props.title,
      tabIndex: this.props.tabIndex,
      onClick: this.handleClick.bind(this),
      disabled: this.props.disabled,
      secondary: this.props.secondary
    }, this.props.children);
  };
  _proto.handleClick = function handleClick(e) {
    if (!this.props.disabled) {
      this.props.onClick(e);
    }
  };
  return Anchor;
}(Component);
Anchor.defaultProps = {
  onClick: noop,
  disabled: false,
  secondary: false
};
export default Anchor;